import * as actions from "./addressesPutActions";
import { CURRENT_CHILD_ORGANIZATION_SET } from "store/domain/currentChildOrganization/currentChildOrganizationActions";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.ADDRESSES_PUT_REQUEST]: (state, action) => ({
    ...state,
    [action.payload.id]: {
      loading: true,
      loaded: false,
      error: null,
      data: null,
    },
  }),

  [actions.ADDRESSES_PUT_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.id]: {
      loading: false,
      loaded: true,
      error: null,
      data: action.data,
    },
  }),

  [actions.ADDRESSES_PUT_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    [action.payload.id]: {
      loading: false,
      loaded: false,
      error: action.error,
      data: null,
    },
  }),

  [CURRENT_CHILD_ORGANIZATION_SET]: () => initialState,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {};

export default function addressesPutReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
